<template>
  <div
    class="modal fade fixed-end"
    tabindex="-1"
    role="dialog"
  >
    <div
      class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="drawer-title">Create Cluster</h2>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="control-label">Name</label>
              <input type="text" class="form-control" v-model="cluster.name" placeholder="client-environment" />
            </div>
            <div class="col-md-6 mb-3 d-flex align-items-end">
              <div class="form-check mb-2">
                <input v-model="cluster.production" type="checkbox" class="form-check-input" id="create_cluster_production" />
                <label class="form-check-label" for="create_cluster_production">Production</label>
              </div>
            </div>
          </div>

          <h3 class="mt-3">Terraform State</h3>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="control-label">State Bucket</label>
              <input type="text" class="form-control" v-model="cluster.terraform_state_bucket" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="control-label">State Key</label>
              <input type="text" class="form-control" v-model="cluster.terraform_state_key" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="control-label">State Region</label>
              <input type="text" class="form-control" v-model="cluster.terraform_state_region" />
            </div>
          </div>

          <h3 class="mt-3">ECS Config</h3>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="control-label">AWS Region</label>
              <input type="text" class="form-control" v-model="cluster.terraform_aws_region" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="control-label">AZ Count</label>
              <input type="text" class="form-control" v-model="cluster.terraform_az_count" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="control-label">Key Name</label>
              <input type="text" class="form-control" v-model="cluster.terraform_key_name" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="control-label">Instance Type</label>
              <input type="text" class="form-control" v-model="cluster.terraform_instance_type" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="control-label">ASG Min</label>
              <input type="text" class="form-control" v-model="cluster.terraform_asg_min" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="control-label">ASG Max</label>
              <input type="text" class="form-control" v-model="cluster.terraform_asg_max" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="control-label">ASG Desired</label>
              <input type="text" class="form-control" v-model="cluster.terraform_asg_desired" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="control-label">Admin CIDR</label>
              <input type="text" class="form-control" v-model="cluster.terraform_admin_cidr_ingress" />
            </div>
          </div>

          <h3 class="mt-3">RDS Master Credentials</h3>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="control-label">Username</label>
              <input type="text" class="form-control" v-model="cluster.terraform_rds_username" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="control-label">Password</label>
              <input type="text" class="form-control" v-model="cluster.terraform_rds_password" />
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <c-button @click="createCluster" class="btn btn-rounded btn-primary">Save</c-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CModal } from '@chameleon/chameleon-vue'
import { notify } from 'utils'
import Cluster from './../../models/cluster.js'

export default {
  extends: CModal,

  data () {
    return {
      cluster: new Cluster()
    }
  },

  mounted () {
    this.addEventListener('open', () => {
      this.cluster = new Cluster()
    })
  },

  methods: {
    createCluster () {
      return client({ path: '/clusters', entity: this.cluster, method: 'POST' }).then(
        (response) => {
          this.$emit('created', response.entity.cluster)
          this.close()
        },
        (response) => {
          const errors = response.entity && response.entity.errors
          const firstValidationIssue = errors ? errors[Object.keys(errors)[0]] : undefined

          if (firstValidationIssue !== undefined) {
            notify.error(firstValidationIssue)
          } else {
            notify.error('Failed to validate the request. Please try again.')
          }
        }
      )
    }
  }
}
</script>
